import apiFetch from '../../apiFetch'

export default function (token, organizedUnitId) {
  return apiFetch({ endPoint: `Entity/puscharseSaleEntitys?organizedUnitId=${organizedUnitId}`, method: 'GET', token: token })
}
